export const education = [
  {
    qualification: "TY.B.com - 2015",
    marks: "CGPI - 6.09",
    name: "ST. Gonsalo Garcia College, Vasai (W)",
    desc: "St. Gonsalo Garcia College is a college in Vasai, Mumbai established in 1984. The college is recognized by and is registered as an institute of the University of Mumbai.",
  },
  {
    qualification: "HSC - 2012",
    marks: "60.83%",
    name: "New English Junior College, Vasai (W)",
    desc: "Founded in 1943, this institution boasts committed and skilled educators who prioritize maximizing students' educational experiences. The establishment has consistently achieved remarkable academic outcomes, with its students also shining in a variety of extracurricular pursuits.",
  },
  {
    qualification: "SSC - 2010",
    marks: "71.45%",
    name: "Citizen English High School, Vasai (W)",
    desc: "Long-standing tradition of excellence coupled with a caring, stimulating, and open ethos. The flexible learning spaces enable the children to engage in rich as well as meaningful experiences, to interact with peers and adults, and to develop lifelong skills. ",
  },
];

export const experience = [
  {
    designation: "Front End Developer",
    company: "Candere by Kalyan Jewellers",
    duration: "February 2022 - September 2025",
    desc: "Create and update CMS pages using the Magento platform. Collaborate with the design and UX teams to revamp webpages, analyze existing webpages to identify areas for improvement. Develop new UI components that align with the Magento framework and design guidelines. Regularly review and update existing UI components. Collaborate with the backend development team to integrate UI changes seamlessly into the Magento platform.",
  },
  {
    designation: "UI/UX Developer",
    company: "Techizer Tech Solutions Pvt. Ltd.",
    duration: "August 2021 - January 2022",
    desc: "Collaborate closely with the project manager and stakeholders to understand user needs, goals, and business objectives. Use tools like Figma to iterate and refine the design based on feedback. Identify and address any design inconsistencies or issues that arise on specific browsers.",
  },
  {
    designation: "Jr. UI Developer",
    company: "INNsight Interactive Pvt. Ltd",
    duration: "May 2019 - July 2021",
    desc: "Developing standalone websites. Rendering design mockup, developing and maintaining entire website and other web properties. Execute task in co-ordination with Project Manager and completely manage the design aspects of the product.",
  },
  {
    designation: "UI/UX Designer",
    company: "Magitt Consultancy (Magnify IT)",
    duration: "Nov 2017 - Feb 2019",
    desc: "Develop UI mockups and prototypes that clearly illustrate how sites function. Identify and troubleshoot UX problems. Conduct layout Adjustments based on user feedback.",
  },
  {
    designation: "Technical Support Associate II",
    company: "Convergys India Pvt. Ltd.",
    duration: "Oct 2015 - Jan 2017",
    desc: "Provide best in class customer service, problem resolution and technical troubleshooting to customer queries over the chat based service. Troubleshoot customer issues related to internet broadband, cable, telephone service and billing.",
  },
];

export const skills = [
  {
    knows: "HTML",
  },
  {
    knows: "CSS, LESS, SCSS, Tailwind CSS",
  },
  {
    knows: "Bootstrap",
  },
  {
    knows: "Javascript / jQuery",
  },
  {
    knows: "React JS",
  },
  {
    knows: "Next JS",
  },
  {
    knows: "Redux Toolkit",
  },
  {
    knows: "React Native",
  },
  {
    knows: "AMP (Accelerated Mobile Pages)",
  },
  {
    knows: "GIT, JIRA",
  },
  {
    knows: "Figma",
  },
  {
    knows: "Adobe Photoshop",
  },
  {
    knows: "Adobe Illustrator",
  },
  {
    knows: "Adobe XD",
  },
];
